module.exports = __webpack_public_path__ + "assets/images/activity_r.486e032a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/activity_r.png
// module id = 670
// module chunks = 1